import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { Input } from "../../form-inputs/inputs";
import { useInput } from "../../../shared/hooks/form-fields";
import { PhotographyContext } from "../../../contexts/photography";

var fitlerTimeout = null;

const LocaleSelector = ({ addTab, existingTabs }) => {
    const { lookups } = useContext(PhotographyContext);
    const [showMenu, setShowMenu] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(lookups.localeOptions);
    const filterInput = useInput("");

    useEffect(() => {
        clearTimeout(fitlerTimeout);
        fitlerTimeout = setTimeout(() => {
            if (!filterInput.value) {
                setFilteredOptions(lookups.localeOptions);
            }

            const newFilteredOptions = lookups.localeOptions.filter((v) => {
                return v.text.toLowerCase().includes(filterInput.value.toLowerCase());
            });

            setFilteredOptions(newFilteredOptions);
        }, 500);
    }, [filterInput.value]);

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const add = (o) => {
        const index = existingTabs.map((v) => v.value).indexOf(o.value);
        addTab(index, o);
        setShowMenu(false);
        filterInput.reset();
    };

    const optionList = filteredOptions.reduce((arr, o) => {
        if (existingTabs.includes(o.value)) {
            return arr;
        }

        arr.push(
            <li key={`tab-option_${o.value}`}>
                <button
                    className="button -text"
                    onClick={() => {
                        add(o);
                    }}
                >
                    {o.text}
                </button>
            </li>
        );

        return arr;
    }, []);

    return (
        <div className="tab-selector">
            <button className="button -primary -small" onClick={toggleMenu}>
                <FontAwesomeIcon icon={faChevronDown} /> Add
            </button>
            {showMenu && (
                <div className="dropdown">
                    <Input name="tab-select-filter" {...filterInput.bind} placeholder="Filter" />
                    <ul>{optionList}</ul>
                </div>
            )}
        </div>
    );
};

export default LocaleSelector;
